import React from 'react';
import { Image as RNImage, ImageProps as RNImageProps } from 'react-native';

export type ImageProps = Omit<RNImageProps, 'defaultSource' | 'onLoad' | 'onError'>;

export default function Image(props: ImageProps) {
  return <RNImage {...props} />;
}
